import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _secondaryControls: {
      width: '3rem',
    },
    increase: {
      name: '',
      width: '4rem',
    },
    code: {
      name: '',
      width: '6rem',
    },
    name: {
      name: '',
      width: '6rem',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
    },
    province: {
      name: '',
      width: '10rem',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
      filter: (val: any, row: any) => `${val ? val?.nameInThai : ''}`,
    },
    district: {
      name: '',
      width: '10rem',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
      filter: (val: any, row: any) => `${val ? val?.nameInThai : ''}`,
    },
    subDistrict: {
      name: 'ตำบล/แขวง',
      width: '10rem',
      class: {
        text: 'text-left',
        cell: 'text-center',
      },
      filter: (val: any) => `${val ? val?.nameInThai : ''}`,
    },
    zipcode: {
      name: '',
      width: '6rem',
      filter: (val: any, row: any) => `${row.item.subDistrict ? row.item.subDistrict?.zipcode : ''}`,
    },
  },
  sortable: [
  ],
};
